"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../../../hooks");
const useStyles = () => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccTaskManagerGradeAndFeedbackCustomTimeStyle = (0, _react.useMemo)(() => {
    const ccTaskManagerGradeAndFeedbackCustomTime = (0, _css.css)({
      marginTop: pxToRem(30)
    });
    return {
      ccTaskManagerGradeAndFeedbackCustomTime
    };
  }, [pxToRem]);
  return {
    'cc-TaskManager__grade-and-feedback-custom-time': ccTaskManagerGradeAndFeedbackCustomTimeStyle.ccTaskManagerGradeAndFeedbackCustomTime
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;